'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var iconStyles = require('../iconStyles.js');
var SvgIcon = require('../../node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var PostcardAppIcon = function PostcardAppIcon(props) {
  return React__default["default"].createElement(SvgIcon["default"], _objectSpread({}, props, {
    viewBox: "0 0 500 500",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }), React__default["default"].createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React__default["default"].createElement("g", {
    id: "Postcard-Marketing"
  }, React__default["default"].createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 79.000000)"
  }, React__default["default"].createElement("rect", {
    id: "Rectangle-16",
    fill: "#EEEEEE",
    x: "0",
    y: "0",
    width: "500",
    height: "340",
    rx: "5"
  }), React__default["default"].createElement("g", {
    id: "Group",
    transform: "translate(13.000000, 317.000000)"
  }, React__default["default"].createElement("polygon", {
    id: "Rectangle-17",
    fill: "#1976D2",
    points: "233.25 0.328125 250.25 0.328125 240 22.328125 223 22.328125"
  }), React__default["default"].createElement("polygon", {
    id: "Rectangle-17",
    fill: "#1976D2",
    points: "297.25 0.328125 314.25 0.328125 304 22.328125 287 22.328125"
  }), React__default["default"].createElement("polygon", {
    id: "Rectangle-17",
    fill: "#F44336",
    points: "329.25 0.328125 346.25 0.328125 336 22.328125 319 22.328125"
  }), React__default["default"].createElement("polygon", {
    id: "Rectangle-17",
    fill: "#F44336",
    points: "393.25 0 410.25 0 400 22 383 22"
  }), React__default["default"].createElement("polygon", {
    id: "Rectangle-17",
    fill: "#1976D2",
    points: "361.25 0.328125 378.25 0.328125 368 22.328125 351 22.328125"
  }), React__default["default"].createElement("polygon", {
    id: "Rectangle-17",
    fill: "#F44336",
    points: "457.25 0 474.25 0 464 22 447 22"
  }), React__default["default"].createElement("polygon", {
    id: "Rectangle-17",
    fill: "#1976D2",
    points: "425.25 0 442.25 0 432 22 415 22"
  }), React__default["default"].createElement("polygon", {
    id: "Rectangle-17",
    fill: "#F44336",
    points: "138 0 155 0 144.75 22 127.75 22"
  }), React__default["default"].createElement("polygon", {
    id: "Rectangle-17",
    fill: "#1976D2",
    points: "106 0 123 0 112.75 22 95.75 22"
  }), React__default["default"].createElement("polygon", {
    id: "Rectangle-17",
    fill: "#F44336",
    points: "202 0 219 0 208.75 22 191.75 22"
  }), React__default["default"].createElement("polygon", {
    id: "Rectangle-17",
    fill: "#1976D2",
    points: "170 0 187 0 176.75 22 159.75 22"
  }), React__default["default"].createElement("polygon", {
    id: "Rectangle-17",
    fill: "#F44336",
    points: "11 0 28 0 17.75 22 0.75 22"
  }), React__default["default"].createElement("polygon", {
    id: "Rectangle-17",
    fill: "#F44336",
    points: "75 0 92 0 81.75 22 64.75 22"
  }), React__default["default"].createElement("polygon", {
    id: "Rectangle-17",
    fill: "#1976D2",
    points: "43 0 60 0 49.75 22 32.75 22"
  }), React__default["default"].createElement("polygon", {
    id: "Rectangle-17",
    fill: "#F44336",
    points: "265.25 0.328125 282.25 0.328125 272 22.328125 255 22.328125"
  })), React__default["default"].createElement("g", {
    id: "Group-Copy",
    transform: "translate(13.000000, 0.000000)"
  }, React__default["default"].createElement("polygon", {
    id: "Rectangle-17",
    fill: "#1976D2",
    points: "233.25 0.328125 250.25 0.328125 240 22.328125 223 22.328125"
  }), React__default["default"].createElement("polygon", {
    id: "Rectangle-17",
    fill: "#1976D2",
    points: "297.25 0.328125 314.25 0.328125 304 22.328125 287 22.328125"
  }), React__default["default"].createElement("polygon", {
    id: "Rectangle-17",
    fill: "#F44336",
    points: "329.25 0.328125 346.25 0.328125 336 22.328125 319 22.328125"
  }), React__default["default"].createElement("polygon", {
    id: "Rectangle-17",
    fill: "#F44336",
    points: "393.25 0 410.25 0 400 22 383 22"
  }), React__default["default"].createElement("polygon", {
    id: "Rectangle-17",
    fill: "#1976D2",
    points: "361.25 0.328125 378.25 0.328125 368 22.328125 351 22.328125"
  }), React__default["default"].createElement("polygon", {
    id: "Rectangle-17",
    fill: "#F44336",
    points: "457.25 0 474.25 0 464 22 447 22"
  }), React__default["default"].createElement("polygon", {
    id: "Rectangle-17",
    fill: "#1976D2",
    points: "425.25 0 442.25 0 432 22 415 22"
  }), React__default["default"].createElement("polygon", {
    id: "Rectangle-17",
    fill: "#F44336",
    points: "138 0 155 0 144.75 22 127.75 22"
  }), React__default["default"].createElement("polygon", {
    id: "Rectangle-17",
    fill: "#1976D2",
    points: "106 0 123 0 112.75 22 95.75 22"
  }), React__default["default"].createElement("polygon", {
    id: "Rectangle-17",
    fill: "#F44336",
    points: "202 0 219 0 208.75 22 191.75 22"
  }), React__default["default"].createElement("polygon", {
    id: "Rectangle-17",
    fill: "#1976D2",
    points: "170 0 187 0 176.75 22 159.75 22"
  }), React__default["default"].createElement("polygon", {
    id: "Rectangle-17",
    fill: "#F44336",
    points: "11 0 28 0 17.75 22 0.75 22"
  }), React__default["default"].createElement("polygon", {
    id: "Rectangle-17",
    fill: "#F44336",
    points: "75 0 92 0 81.75 22 64.75 22"
  }), React__default["default"].createElement("polygon", {
    id: "Rectangle-17",
    fill: "#1976D2",
    points: "43 0 60 0 49.75 22 32.75 22"
  }), React__default["default"].createElement("polygon", {
    id: "Rectangle-17",
    fill: "#F44336",
    points: "265.25 0.328125 282.25 0.328125 272 22.328125 255 22.328125"
  })), React__default["default"].createElement("rect", {
    id: "Rectangle-18",
    fill: "#E0E0E0",
    x: "404",
    y: "64",
    width: "69",
    height: "75"
  }), React__default["default"].createElement("rect", {
    id: "Rectangle-18",
    fill: "#E0E0E0",
    x: "271",
    y: "183",
    width: "202",
    height: "20"
  }), React__default["default"].createElement("rect", {
    id: "Rectangle-18",
    fill: "#E0E0E0",
    x: "27",
    y: "64",
    width: "202",
    height: "199"
  }), React__default["default"].createElement("rect", {
    id: "Rectangle-18",
    fill: "#E0E0E0",
    x: "271",
    y: "213",
    width: "202",
    height: "20"
  }), React__default["default"].createElement("rect", {
    id: "Rectangle-18",
    fill: "#E0E0E0",
    x: "271",
    y: "243",
    width: "202",
    height: "20"
  })))));
};

var PostcardAppIcon$1 = iconStyles()(PostcardAppIcon);

module.exports = PostcardAppIcon$1;
